import { all } from "redux-saga/effects";
import { danhSachTroCapSaga } from "./danhSachTroCapSaga";

export default function* troCapSaga() {
  yield all([danhSachTroCapSaga()]);
}
